import Vue from 'vue'
import Router from 'vue-router'
import homePage from '@/components/homePage/homePage'  //首页
import companyDynamics from '@/components/companyDynamics/companyDynamics' //公司动态
import companyDetail from '@/components/companyDynamics/companyDetail' //公司详情
import caseResults from '@/components/caseResults/caseResults' //案例成果
import caseDetail from '@/components/caseResults/caseDetail' //案例成果详情
import demoSystem from '@/components/demoSystem/demoSystem' //演示系统

import brandCenter from '@/components/brandCenter/brandCenter' //品牌中心
import yfyjsMore from '@/components/homePage/yfyjsMore' //研发与建设更多
import ghygwMore from '@/components/homePage/ghygwMore' //规划与顾问更多
import tzyyyMore from '@/components/homePage/tzyyyMore' //投资与运营更多
import mddyxMore from '@/components/homePage/mddyxMore' //目的地营销更多
import listMsg from '@/components/homePage/listmsg' //首页列表信息

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: homePage
    },
    {
      path: '/homePage',
      name: 'homePage',
      meta:'homePage',
      component: homePage
    },
    //公司动态
    {
      path: '/companyDynamics',
      name: 'companyDynamics',
      meta:'companyDynamics',
      component: companyDynamics
    },
    {
      path: '/companyDetail',
      name: 'companyDetail',
      component: companyDetail
    },
    //案例成果
    {
      path: '/caseResults',
      name: 'caseResults',
      meta:'caseResults',
      component: caseResults
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      component: caseDetail
    },
    //演示系统
    {
        path: '/demoSystem',
        name: 'demoSystem',
        meta:'demoSystem',
        component: demoSystem
    },
    {
      path: '/brandCenter',  // 品牌中心
      name: 'brandCenter',
      meta:'brandCenter',
      component: brandCenter
    },
    {
      path: '/yfyjsMore',
      name: 'yfyjsMore',
      component: yfyjsMore
    },
    {
      path: '/ghygwMore',
      name: 'ghygwMore',
      component: ghygwMore
    },
    {
      path: '/tzyyyMore',
      name: 'tzyyyMore',
      component: tzyyyMore
    },
    {
      path: '/mddyxMore',
      name: 'mddyxMore',
      component: mddyxMore
    },
    {
      path: '/listMsg',
      name: 'listMsg',
      component: listMsg
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js